import pz1 from '../images/payzapp/1.png'
import pz2 from '../images/payzapp/2.png'

import peyScreen1 from '../images/pey/1.png'
import peyScreen2 from '../images/pey/2.png'
import peyLogo from '../images/pey/logo.png'

import orgamax1 from '../images/orgamax/1.png'
import orgamax2 from '../images/orgamax/2.png'
import orgamaxLogo from '../images/orgamax/logo.png'

import markets1 from '../images/markets/MarketsHome.png'
import markets2 from '../images/markets/MarketseStore.png'
import marketsLogo from '../images/markets/logo.png'
import pzLogo from '../images/payzapp/pzAppIcon.webp'
import appstore from '../images/appstore.png'

import dp from '../images/dp2.jpeg'
import logo from '../images/logo.png'

const payzapp = {
    screen1 : pz1,
    screen2 : pz2,
    logo    : pzLogo
}

const pey = {
    screen1 : peyScreen1,
    screen2 : peyScreen2,
    logo    : peyLogo
}

const orgamax = {
    screen1 : orgamax1,
    screen2 : orgamax2,
    logo    : orgamaxLogo
}

const markets = {
    screen1 : markets1,
    screen2 : markets2,
    logo    : marketsLogo,
}

const others = {
    appstore: appstore
}

export default {
    payzapp,
    pey,
    orgamax,
    dp,
    markets, 
    others,
    logo
}